import individualReportApi from "@/api/article/individualReportApi";
export default {
  namespaced: true,
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await individualReportApi.addOrUpate(form);
        dispatch('NOTIFY_MSG', 'individualReport.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {reportId}) {
      try {
        await individualReportApi.delete(reportId);
        dispatch('NOTIFY_MSG', 'individualReport.notification.delete',
          {root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
